import angular from 'angular';
import FactModalConf from './fact.config';

export default angular.module('modal.fact', [])
  .constant('FactModalConf', FactModalConf)
  .name;



// WEBPACK FOOTER //
// ./project/modals/fact/index.js